import React, { useState,useEffect,useRef } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Avatar,
  TextField,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,Select,MenuItem,FormControl,InputLabel,CircularProgress
} from "@mui/material";

import {
  WhatsApp,
  People,
  Message,
  Campaign,
  CloudUpload as UploadIcon
} from "@mui/icons-material";
import sampleTemplate from "./sample_contacts.xlsx";
import  bg from "../Logos/med_icon3.png"
import whatsappBg from "../Logos/whatsapp_bg.png";

import { getContacts ,getMessages,sendMessage,sendTemplate,uploadContacts,addContacts,getTemplates,addTemplate,deleteContacts,deleteTemplate,deleteContact} from "./WhatsappService";
import axios from 'axios';
import { apiRequest } from "../../fetchSetup";

export default function WhatsappDashboard() {
  const [contacts, setContacts] = useState([]);
  const [messages, setMessages] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [sendingTemplate, setSendingTemplate] = useState(false);
  const [broadcastMessage, setBroadcastMessage] = useState("");
  const [sendingBroadcast, setSendingBroadcast] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateVariables, setTemplateVariables] = useState([]);
  const [openTemplate, setOpenTemplate] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [selectedImage, setSelectedImage] = useState([]);
  const [imageUrl,setImageUrl]=useState("")

  const fileInputRef = useRef(null);
const [newTemplate, setNewTemplate] = useState({
    template_id: "",
    name: "",
    language: "en",
    type: "TEXT",
    variables: [],
    image_url:""
});
const BASE_URL= process.env.REACT_APP_WHATSAPP_API_URL;

const [variableCount, setVariableCount] = useState(0);

const [newContact, setNewContact] = useState({
    name: "",
    phone: "",
});
  
useEffect(() => {
  fetchContacts();
  fetchTemplates();

}, []);

useEffect(() => {
  if (selectedContact?.phone) {
    fetchMessages(selectedContact.phone);
  }
}, [selectedContact]);



const handleUploadReport = async () => {
    if (selectedImage.length === 0 ) return;
  
    setUploading(true);
    const formData = new FormData();
  
    selectedImage.forEach(file => formData.append('file', file));
  
    try {
      const response = await apiRequest(`${BASE_URL}api/flask/messages/upload-images`, {
        method: 'POST',
        body: formData
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to upload report');
      }
  
      const result = await response.json();
      setNewTemplate({
                ...newTemplate,
                image_url: result.cloudfront_url
            })
    setUploading(false);

      console.log(result)
  
    } catch (err) {
      console.error('Upload report error:', err);
          setUploading(false);

    } 
  };
  

const handleBroadcastMessage = async () => {
  if (!broadcastMessage.trim()) {
    alert("Please enter a message");
    return;
  }

  try {

        setSendingBroadcast(true);

        await Promise.all(

            contacts.map(contact =>
                sendTemplate({
                    phone: contact.phone,
                    template_id: selectedTemplate.id,
                    params: templateVariables,
                    type:selectedTemplate.type,
                    image_url:selectedTemplate.image_url ||""
                })
            )

        );

        alert("Template sent successfully");

    } catch (err) {

        console.error(err);

    } finally {

        setSendingBroadcast(false);

    }
};
const handleAddTemplate = async () => {

    try {

        await addTemplate(newTemplate);

        alert("Template added successfully");

        setOpenTemplate(false);

        setNewTemplate({
            template_id: "",
            name: "",
            language: "en",
            category: "MARKETING",
            header_type: "TEXT",
            variables: [],
            image_url:""
        });

        setVariableCount(0);

        fetchTemplates();

    } catch (err) {

        console.error(err);
        alert("Failed to add template");

    }

};

const handleDeleteAllContacts = async () => {
  const confirmed = window.confirm(
    "Are you sure you want to delete ALL contacts? This action cannot be undone."
  );

  if (!confirmed) return;

  try {
    await deleteContacts();

    setContacts([]);
    setSelectedContact(null);

   
  } catch (err) {
    window.alert("Failed to delete contacts", {
      variant: "error",
    });
  }
};

const handleFileSelect = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setSelectedFile(file);
};

const handleImageSelect = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setSelectedImage([file]);
};


const handleDeleteContact = async (contact) => {
  const confirmed = window.confirm(
    `Delete Contact "${contact}"?`
  );

  if (!confirmed) return;

  try {
    await deleteContact(contact); // or template.template_id depending on your API

    fetchContacts();

    alert("Template deleted successfully");
  } catch (err) {
    console.error(err);
    alert("Failed to delete template");
  }
};
const handleDeleteTemplate = async (template) => {
  const confirmed = window.confirm(
    `Delete template "${template.name}"?`
  );

  if (!confirmed) return;

  try {
    await deleteTemplate(template.id); // or template.template_id depending on your API

    if (selectedTemplate?.id === template.id) {
      setSelectedTemplate(null);
      setTemplateVariables([]);
    }

    fetchTemplates();

    alert("Template deleted successfully");
  } catch (err) {
    console.error(err);
    alert("Failed to delete template");
  }
};
const fetchTemplates = async () => {
    try {
        const response = await getTemplates();
        setTemplates(response.data || []);
    } catch (err) {
        console.error(err);
    }
};
const handleTemplateChange = (e) => {
  if (e.target.value==""){
    alert("Select template");
    return
  }

    const template = templates.find(
        t => t.id === e.target.value
    );

    setSelectedTemplate(template);

    setTemplateVariables(
        template.variables.map(() => "")
    );
};

const handleSendMessage = async () => {
  if (!message.trim()) return;

  if (!selectedContact) return;

  try {
    setLoading(true);

    await sendMessage({
      phone: selectedContact.phone,
      message,
    });

    setMessage("");

    await fetchMessages(
      selectedContact.phone
    );
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

const handleUpload = async (e) => {
   if (!selectedFile) {
        alert("Please select a file.");
        return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
        setUploading(true);

        await uploadContacts(formData);

        fetchContacts();

        alert("Contacts uploaded successfully.");

        setSelectedFile(null);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    } catch (err) {
        console.log(err);
        alert("Upload failed.");
    } finally {
        setUploading(false);
    }

};

const handleAddContact = async () => {
  try {
    await addContacts(newContact)

    setOpenAdd(false);

    setNewContact({
      name: "",
      phone: "",
    });

    fetchContacts();
  } catch (err) {
    console.error(err);
    alert("Failed to add contact");
  }
};
const handleSendWelcomeTemplate = async () => {
  try {
    setSendingTemplate(true);

    await sendTemplate({id: selectedTemplate.id,
                      params: templateVariables,
                      type:selectedTemplate.type,
                      image_url:selectedTemplate.image_url ||""
                    });

    alert("Welcome template sent successfully");
  } catch (error) {
    console.error(error);
    alert("Failed to send template");
  } finally {
    setSendingTemplate(false);
  }
};
const fetchContacts = async () => {
  try {
    const response = await getContacts();

    const contactList = response.data || [];

    setContacts(contactList);

    if (contactList.length > 0) {
      setSelectedContact(contactList[0]);
    }
  } catch (error) {
    console.error(error);
  }
};

const fetchMessages = async (phone) => {
  try {
    const response = await getMessages(phone);

    setMessages(response.data || []);
  } catch (error) {
    console.error(error);
  }
};
  return (
    <Box sx={{  bgcolor: "#f4f6f8", minHeight: "100vh",  ml: { md: '300px' }  }}>
      <Typography variant="h4" fontWeight="bold" mb={3} sx={{ 
                 backgroundImage: `
                  linear-gradient(135deg, rgba(0,109,119,0.9) 0%, rgba(0, 169, 181, 0.68) 100%),
                  url(${bg})
                `,
                height:"100px",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat" ,     
                color: "white",
                  p: 4,
                  borderRadius: 3,
                  mb: 4,
                  position: "relative",
                  overflow: "hidden"
                }}>
        WhatsApp Business Dashboard
      </Typography>

      {/* Stats */}
      <Grid container spacing={3}>

        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>
              <People color="primary" />
              <Typography variant="h6">
                <strong>{contacts.length}</strong> Contacts
              </Typography>
            </CardContent>
          </Card>
        </Grid>
<Grid container spacing={3} >
  <Grid item xs={12} md={6}>
    <Card>
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box>
          <Typography variant="h6">
            Promotion & Campaign
          </Typography>

          <Typography color="text.secondary">
            Send the approved templates to all contacts.
          </Typography>
        </Box>
        <FormControl sx={{ mt: 2 ,width:"200px"}}>
  <InputLabel id="template-select-label">
    Template
  </InputLabel>


<Select
  labelId="template-select-label"
  value={selectedTemplate?.id || ""}
  label="Template"
  onChange={handleTemplateChange}
  renderValue={(selected) => {
    const template = templates.find(
      (template) => template.id === selected
    );

    return template?.name || "";
  }}
>
  {templates.map((template) => (
    <MenuItem key={template.id} value={template.id}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Typography>
          {template.name}
        </Typography>

        <Button
          color="error"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteTemplate(template);
          }}
        >
          Delete
        </Button>
      </Box>
    </MenuItem>
  ))}
</Select>

</FormControl>

<Button
    variant="contained"
    onClick={() => setOpenTemplate(true)}
    sx={{
        bgcolor:"#00838F",
        mr:1
    }}
>
    Add Template
</Button>
{selectedTemplate && templateVariables.map((value, index) => (
  <TextField
    key={index}
    fullWidth
    margin="dense"
    label={
      selectedTemplate.variables?.[index]?.name ||
      `Parameter ${index + 1}`
    }
    placeholder={
      selectedTemplate.variables?.[index]?.example ||
      `Enter value for parameter ${index + 1}`
    }
    value={value}
    onChange={(e) => {
      const params = [...templateVariables];
      params[index] = e.target.value;
      setTemplateVariables(params);
    }}
  />
))}
        <Button
          variant="contained"
          startIcon={<Campaign />}
          disabled={sendingTemplate}
          onClick={handleSendWelcomeTemplate}
          sx={{
            background:
              "linear-gradient(135deg, #006D77 0%, #00a8b5 100%)",
          }}
        >
          {sendingTemplate
            ? "Sending..."
            : `Send to ${contacts.length} Contacts`}
        </Button>
      </CardContent>
    </Card>
  </Grid>

</Grid>
</Grid>
<Grid container spacing={3} mt={2}  sx={{
   
    justifyContent: "space-between",
    alignItems: "flex-start",
  }}>
  {/* Left Section */}
  <Grid item xs={12} md={5}>
    <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
<Button
    variant="contained"
    onClick={() => setOpenAdd(true)}
    sx={{ bgcolor: "#006D77",marginRight:"10px"}}
>
    Add Contact
</Button>
<Button
  variant="contained"
  color="error"
  onClick={handleDeleteAllContacts}
>
  Delete All Contacts
</Button>
 <Button
        variant="outlined"
        component="a"
        href={sampleTemplate}
        download="sample_contacts.xlsx"
      >
        Sample Format
      </Button>
      </Box>
<Card
    variant="outlined"
    sx={{
        p: 2,
        mt: 2,
        width: "100%",
        maxWidth: 420,
        border: "2px dashed #00a8b5",
        borderRadius: 2,
        bgcolor: "#fafefe",
    }}
>
    <Typography
        variant="subtitle1"
        fontWeight={600}
        gutterBottom
    >
        Upload Contacts
    </Typography>

    <Typography
        variant="body2"
        color="text.secondary"
        mb={2}
    >
        Upload an Excel or CSV file containing customer contacts.
    </Typography>

    <Button
        component="label"
        variant="outlined"
        fullWidth
    >
        📎 Choose File

        <input
            hidden
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileSelect}
        />
    </Button>

    {selectedFile && (
        <Box
            sx={{
                mt: 2,
                p: 1.5,
                bgcolor: "#f5f5f5",
                borderRadius: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <Box>
                <Typography fontWeight={600}>
                    {selectedFile.name}
                </Typography>

                <Typography
                    variant="caption"
                    color="text.secondary"
                >
                    {(selectedFile.size / 1024).toFixed(1)} KB
                </Typography>
            </Box>

            <Button
                color="error"
                size="small"
                onClick={() => {
                    setSelectedFile(null);
                    fileInputRef.current.value = "";
                }}
            >
                Remove
            </Button>
        </Box>
    )}

    <Button
        fullWidth
        variant="contained"
        sx={{
            mt: 2,
            bgcolor: "#006D77",
        }}
        disabled={!selectedFile || uploading}
        onClick={handleUpload}
    >
        {uploading ? "Uploading..." : "Upload Contacts"}
    </Button>
</Card>
  </Grid>
      {/* Chat Section */}
        <Grid item xs={12} md={7}>

           <Box
    sx={{
      display: "flex",
      gap: 2,
      height: "65vh",
    }}
  >
  <Paper
    sx={{
      height: "65vh",
      width: 300,
      display: "flex",
      flexDirection: "column",
    }}
  >
    
    <Box
      sx={{
        background: "linear-gradient(135deg, #006D77 0%, #00a8b5 100%)",
        color: "white",
      }}
    >
      
      <Typography p={2} variant="h6">
        Contacts
      </Typography>
    </Box>

    <Divider />

    <Box sx={{ flex: 1, overflowY: "auto" }}>
      <List>
        {contacts.map((contact) => (
          <ListItem
            button
            key={contact.id}
            onClick={() => setSelectedContact(contact)}
          >
            <Avatar sx={{ mr: 2 }}>
              {(contact.name || "U")[0]}
            </Avatar>

            <ListItemText
              primary={contact.name}
              secondary={contact.phone}
            />
             <Button
              color="error"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteContact(contact.phone);
              }}
            >
              Delete
            </Button>
          </ListItem>
        ))}
      </List>
    </Box>
  </Paper>
   <Card
      sx={{
        height: "65vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        bgcolor: "#F8FFFE",
        border: "1px solid #E0F2F1",
      }}
    >
      <img
        src={whatsappBg}
        alt="WhatsApp Management"
        style={{
          width: "85%",
          maxWidth: 320,
          objectFit: "contain",
        }}
      />
      </Card>
      </Box>
</Grid>
      </Grid> 
      <Dialog
    open={openTemplate}
    onClose={() => setOpenTemplate(false)}
    maxWidth="sm"
    fullWidth
>

<DialogTitle>
    Add WhatsApp Template
</DialogTitle>

<DialogContent>

<TextField
    fullWidth
    margin="dense"
    label="Template ID"
    value={newTemplate.template_id}
    onChange={(e)=>
        setNewTemplate({
            ...newTemplate,
            template_id:e.target.value
        })
    }
/>

<TextField
    fullWidth
    margin="dense"
    label="Template Name"
    value={newTemplate.name}
    onChange={(e)=>
        setNewTemplate({
            ...newTemplate,
            name:e.target.value
        })
    }
/>

<TextField
    fullWidth
    margin="dense"
    label="Language"
    value={newTemplate.language}
    onChange={(e)=>
        setNewTemplate({
            ...newTemplate,
            language:e.target.value
        })
    }
/>
<FormControl fullWidth margin="dense">
    <InputLabel id="template-type-label">
        Template Type
    </InputLabel>

    <Select
        labelId="template-type-label"
        value={newTemplate.type}
        label="Template Type"
        onChange={(e) =>
            setNewTemplate({
                ...newTemplate,
                type: e.target.value
            })
        }
    >
        <MenuItem value="TEXT">
            Text
        </MenuItem>

        <MenuItem value="IMAGE">
            Image
        </MenuItem>
    </Select>
</FormControl>

<TextField
    fullWidth
    margin="dense"
    type="number"
    label="Number of Variables"
    value={variableCount}
    onChange={(e)=>{

        const count = Number(e.target.value);

        setVariableCount(count);

        setNewTemplate({
            ...newTemplate,
            variables:Array.from(
                {length:count},
                (_,i)=>({
                    index:i+1,
                    name:"",
                    example:""
                })
            )
        });

    }}
/>
{newTemplate.type === "IMAGE" && (
  <>
    <TextField
        fullWidth
        margin="dense"
        label="Image URL"
        placeholder="https://example.com/image.jpg"
        value={newTemplate.image_url}
        onChange={(e) =>
            setNewTemplate({
                ...newTemplate,
                image_url: e.target.value
            })
        }
    />
     {/* Upload Section */}
                  <Box sx={{ mb: 3, p: 2, bgcolor: '#F0F9FF', borderRadius: 2 }}>
                    <Typography variant="subtitle2" fontWeight="600" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <UploadIcon />
                      Upload Image
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<UploadIcon />}
                        sx={{
                          borderColor: '#006D77',
                          color: '#006D77',
                          '&:hover': {
                            borderColor: '#005761',
                            bgcolor: 'rgba(0, 109, 119, 0.08)'
                          }
                        }}
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          accept=".png,.jpg,.jpeg"
                          multiple
                          onChange={handleImageSelect}
                        />
                      </Button>
                                      
                  {Array.isArray(selectedImage) && selectedImage.length > 0 && (  <>
                      <Box sx={{ flex: 1, minWidth: 200 }}>
                        {selectedImage.map((file, idx) => (
                          <Box key={idx} sx={{ mb: 1 }}>
                            <Typography variant="body2" fontWeight="600" noWrap>
                              {file.name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {(file.size / 1024 / 1024).toFixed(2)} MB
                            </Typography>
                          </Box>
                        ))}
                      </Box>

                      <Button
                        variant="contained"
                        startIcon={
                          uploading ? (
                            <CircularProgress size={20} sx={{ color: 'white' }} />
                          ) : (
                            <UploadIcon />
                          )
                        }
                        onClick={handleUploadReport}
                        disabled={uploading}
                        sx={{
                          bgcolor: '#006D77',
                          '&:hover': { bgcolor: '#005761' }
                        }}
                      >
                        {uploading ? 'Uploading...' : 'Upload'}
                      </Button>
                    </>
                  )}
                  </Box>
                  </Box>
                  </>
)}
{newTemplate.variables.map((variable,index)=>(

<Box
    key={index}
    sx={{
        display:"flex",
        gap:2,
        mt:2
    }}
>

<TextField
    fullWidth
    label={`Variable ${index+1}`}
    value={variable.name}
    onChange={(e)=>{

        const vars=[...newTemplate.variables];

        vars[index].name=e.target.value;

        setNewTemplate({
            ...newTemplate,
            variables:vars
        });

    }}
/>

<TextField
    fullWidth
    label="Example"
    value={variable.example}
    onChange={(e)=>{

        const vars=[...newTemplate.variables];

        vars[index].example=e.target.value;

        setNewTemplate({
            ...newTemplate,
            variables:vars
        });

    }}
/>

</Box>

))}

</DialogContent>

<DialogActions>

<Button
    onClick={()=>
        setOpenTemplate(false)
    }
>
    Cancel
</Button>

<Button
    variant="contained"
    onClick={handleAddTemplate}
>
    Save
</Button>

</DialogActions>

</Dialog>
      <Dialog open={openAdd} onClose={() => setOpenAdd(false)}>
    <DialogTitle>Add Contact</DialogTitle>

    <DialogContent>
        <TextField
            fullWidth
            margin="dense"
            label="Name"
            value={newContact.name}
            onChange={(e) =>
                setNewContact({
                    ...newContact,
                    name: e.target.value,
                })
            }
        />

        <TextField
            fullWidth
            margin="dense"
            label="Phone"
            value={newContact.phone}
             onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "").slice(0, 10);

            setNewContact({
              ...newContact,
              phone: value,
            });
          }}
          inputProps={{
            maxLength: 10,
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
        />
    </DialogContent>

    <DialogActions>
        <Button onClick={() => setOpenAdd(false)}>
            Cancel
        </Button>

        <Button
            variant="contained"
            onClick={handleAddContact}
        >
            Save
        </Button>
    </DialogActions>
</Dialog>
    </Box>
  );
}